import AppLayout from '../components/layout/AppLayout'
import { initialSteps, StepIDs } from '../constants/stepConstants'
import { Routes } from '../constants/routeConstants'
import Step from '../helpers/step'
import { useRouter } from 'next/router'
import { createContext, ReactElement, useEffect, useState } from 'react'
import { StepState } from '../types/steps'

interface AppProviderValue {
    steps: Step[]
    areStepsVisible: boolean
    goToStep?: (stepId: StepIDs) => void
}

export const AppContext = createContext<AppProviderValue>({
    areStepsVisible: false,
    steps: [],
})

interface AppProviderProps {
    children: ReactElement[] | ReactElement
}

const ROUTES_WITHOUT_STEPS: Routes[] = [Routes.CHECK, Routes.REVIEW_FORM, Routes.REVIEW_SUMMARY]

export const AppProvider = ({ children }: AppProviderProps): JSX.Element => {
    const router = useRouter()
    const [areStepsVisible, setStepsVisibility] = useState<boolean>(false)
    const [steps, setSteps] = useState<Step[]>(initialSteps)

    const goToStep = (stepId: StepIDs): void => {
        const updatedSteps: Step[] = [...steps]

        const stepToGoToIndex = updatedSteps.findIndex((step) => step.id === stepId)
        updatedSteps.map((step, index) => {
            if (index < stepToGoToIndex) {
                step.setState(StepState.DONE)
            } else if (index === stepToGoToIndex) {
                step.setState(StepState.PENDING)
            } else {
                step.setState(StepState.TO_DO)
            }
            return step
        })

        setSteps(updatedSteps)
    }

    useEffect(() => {
        setStepsVisibility(!ROUTES_WITHOUT_STEPS.includes(router.pathname as Routes))
    }, [router.pathname])

    const providerValue: AppProviderValue = {
        areStepsVisible,
        steps,
        goToStep,
    }

    return (
        <AppContext.Provider value={providerValue}>
            <AppLayout>{children}</AppLayout>
        </AppContext.Provider>
    )
}
